import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import theme from './StandardReplies.module.scss';
import { DateDisplay } from '@/components/localization';
import { classnames } from '@/utils/html';
import EditStandardReplyModal from './EditStandardReplyModal';
import { StandardReply } from '@/types';
import { deleteStandardReply } from '@/services/standard-replies';
import DeleteStandardReplyModal from './DeleteStandardReplyModal';
import { Toast } from '@ygtechnologies/bygr-frontend-component-library';

interface StandardReplyCardProps {
    standardReply: StandardReply;
    onChange(): void;
}

const StandardReplyCard: React.FC<StandardReplyCardProps> = ({ standardReply, onChange }) => {
    const [editStandardReplyModalIsOpen, setEditStandardReplyModalIsOpen] = useState(false);
    const [deleteStandardReplyModalIsOpen, setDeleteStandardReplyModalIsOpen] = useState(false);

    const onSave = async () => {
        onChange();
    };

    const handleDeleteClick = () => {
        setEditStandardReplyModalIsOpen(false);
        setDeleteStandardReplyModalIsOpen(true);
    };

    const confirmDeleteStandardReply = async () => {
        setDeleteStandardReplyModalIsOpen(false);
        // setEditStandardReplyModalIsOpen(false);
        await deleteStandardReply(standardReply.id!);
        onChange();
        Toast.success(<Trans>Standard reply has been deleted</Trans>);
    };

    return (
        <>
            <div
                id={standardReply.id?.toString()}
                className={theme.cardContainer}
                onClick={() => setEditStandardReplyModalIsOpen(true)}>
                <div className={theme.infoContainer}>
                    <div className={theme.cardInfo}>
                        <div className={theme.title}>
                            <Trans>{standardReply.title}</Trans>
                        </div>
                        <div className={theme.text}>
                            <Trans>{standardReply.text}</Trans>
                        </div>
                    </div>
                    <div className={theme.dateContainer}>
                        <div className={theme.date}>
                            <div
                                className={classnames(
                                    { [theme.noCommentBadge]: !standardReply.comment },
                                    theme.commentBadge
                                )}>
                                <Trans>Comment</Trans>
                            </div>
                            {standardReply.updateDate === null ? (
                                <div>
                                    <Trans>Created</Trans> <DateDisplay value={standardReply.createDate} />
                                </div>
                            ) : (
                                <div>
                                    <Trans>Updated</Trans> <DateDisplay value={standardReply.updateDate} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <FontAwesomeIcon icon={faChevronRight} size="lg" className={theme.chevronIcon} />
            </div>
            {editStandardReplyModalIsOpen && (
                <EditStandardReplyModal
                    isOpen={editStandardReplyModalIsOpen}
                    toggle={() => setEditStandardReplyModalIsOpen(false)}
                    standardReply={standardReply}
                    onSave={onSave}
                    onDeleteClick={handleDeleteClick}
                />
            )}

            {deleteStandardReplyModalIsOpen && (
                <DeleteStandardReplyModal
                    isOpen={deleteStandardReplyModalIsOpen}
                    toggle={() => {
                        setDeleteStandardReplyModalIsOpen(false);
                        setEditStandardReplyModalIsOpen(true);
                    }}
                    confirmDeleteReply={confirmDeleteStandardReply}
                />
            )}
        </>
    );
};

export default StandardReplyCard;